import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteTextMessage as DeleteTextMessageMutation,
    DeleteTextMessageVariables as DeleteTextMessageMutationVariables,
} from 'nutshell-graphql-types';

import GET_CHANNEL_EVENTS from '../../../graphql/queries/get-channel-events.graphql';

import DELETE_TEXT_MESSAGE from '../mutations/delete-text-message.graphql';

export const useDeleteTextMessage = (): {
    deleteTextMessage: (arg1: {
        messageId: string;
        channelId: string | null | undefined;
        threadId: string | null | undefined;
    }) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteTextMessage, {loading, error}] = useMutation<
        DeleteTextMessageMutation,
        DeleteTextMessageMutationVariables
    >(DELETE_TEXT_MESSAGE);

    return {
        deleteTextMessage: (input: {
            messageId: string;
            channelId: string | null | undefined;
            threadId: string | null | undefined;
        }) => {
            const {messageId, channelId, threadId} = input;

            return deleteTextMessage({
                variables: {input: {messageId}},
                update: (proxy, mutationResults) => {
                    const deletedMessage =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.textMessageDelete &&
                        mutationResults.data.textMessageDelete.message;

                    const cacheResult = proxy.readQuery({
                        query: GET_CHANNEL_EVENTS,
                        variables: {
                            channelId,
                            threadId,
                            first: 40,
                        },
                    });

                    if (cacheResult && deletedMessage) {
                        proxy.writeQuery({
                            query: GET_CHANNEL_EVENTS,
                            variables: {
                                channelId,
                                threadId,
                                first: 40,
                            },
                            data: {
                                ...cacheResult,
                                channelEvents: {
                                    // @ts-expect-error
                                    ...cacheResult.channelEvents,
                                    edges: [
                                        // @ts-expect-error
                                        ...cacheResult.channelEvents.edges.filter(
                                            // @ts-expect-error
                                            (edge) => edge.node.payload.id !== deletedMessage.id
                                        ),
                                    ],
                                },
                            },
                        });
                    }
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
